import type { JSX, ReactElement } from "react";

import { Tooltip } from "@similarweb/ui-components";

interface IWrapWithPopoverProps {
    content: JSX.Element;
    tooltipText: string;
    shouldWrap: boolean;
}
export const wrapWithTooltip = ({ content, tooltipText, shouldWrap = true }: IWrapWithPopoverProps): ReactElement => {
    return shouldWrap ? (
        <Tooltip
            placement={"top"}
            content={tooltipText}
        >
            {content}
        </Tooltip>
    ) : (
        content
    );
};
